import * as types from "@root/types";
import cx from "classnames";
import React, { FC } from "react";

interface IconProps {
  name: types.IconName;
  className?: string;
  ariaLabel?: string;
}

const Icon: FC<IconProps> = ({ name, className, ariaLabel }) => {
  const clz = cx(`icon-${name}`, className);
  return <i role="img" className={clz} aria-label={ariaLabel} />;
};

export { Icon };
